Namespace('Settings.Views.ChatbotConfiguration')

class Settings.Views.ChatbotConfiguration.IntentsTableDescriptionView extends Backbone.View
  template: JST['backbone/templates/settings/chatbot_configuration/intents_table_description']
  className: 'intents-table-description'

  initialize: (intentsCollection) ->
    @intentsCollection = intentsCollection

  render: =>
    @$el.html(@template(
      normalFlowCount: @intentsCollection.normalFlow().length
      disabledFlowCount: @intentsCollection.disabledFlow().length
      fallbackFlowCount: @intentsCollection.fallbackFlow().length
    ))
    @
